import React, { useState } from "react";
//import BarcodeScannerComponent from "react-webcam-barcode-scanner";
import "./css.css";
import ModalProduct from "./ModalProduct";

export default function ScannerCodeBar() {
  const products = JSON.parse(localStorage.getItem("products"));

  const [search, setSearch] = useState("");

  const productsToRender = Array.isArray(products)
    ? search.length > 0
      ? products
          .filter(
            (product) =>
              product._id.toString().includes(search) ||
              (product.name &&
                product.name.toUpperCase().includes(search.toUpperCase()))
          )
          .sort((a, b) => a._id - b._id)
      : products.sort((a, b) => a._id - b._id)
    : [];

  const [showModalProduct, setShowModalProduct] = useState(null);

  const saveProduct = ({ _id, name, price }, id = null) => {
    let newProducts = Array.isArray(
      JSON.parse(localStorage.getItem("products"))
    )
      ? JSON.parse(localStorage.getItem("products"))
      : [];
    if (id) {
      if (_id !== id) {
        if (newProducts.find((product) => product._id === _id)) {
          alert("Ya existe el codigo");
          return;
        }
      }
      newProducts = newProducts.filter((product) => product._id !== id);
    } else {
      if (newProducts.find((product) => product._id.toString() === _id)) {
        alert("Ya existe el codigo");
        return;
      }
    }

    newProducts.push({ _id, name, price });
    localStorage.setItem("products", JSON.stringify(newProducts));
    setShowModalProduct(null);
  };

  const deleteProduct = (_id) => {
    if (!window.confirm("Eliminar?")) return;
    if (!_id) {
      alert("No paso el codigo.");
      return;
    }
    let newProducts = Array.isArray(
      JSON.parse(localStorage.getItem("products"))
    )
      ? JSON.parse(localStorage.getItem("products"))
      : [];
    newProducts = newProducts.filter((product) => product._id !== _id);

    localStorage.setItem("products", JSON.stringify(newProducts));
    setShowModalProduct(null);
  };

  //const [showScanner, setShowScanner] = useState(false);

  return (
    <div className="container-scanner">
      {showModalProduct && (
        <ModalProduct
          closeModal={() => setShowModalProduct(null)}
          product={showModalProduct}
          saveProduct={saveProduct}
          deleteProduct={deleteProduct}
        />
      )}
      <div className="container-buttons">
        <button
          className="button"
          onClick={() =>
            setShowModalProduct({
              _id: "",
              name: "",
              price: 0,
            })
          }
        >
          Agregar
        </button>
        {/*<button className="button" onClick={() => setShowScanner(!showScanner)}>
          Escanear con camara
        </button>
        {showScanner && (
          <BarcodeScannerComponent
            width={500}
            height={500}
            onUpdate={(_, result) => {
              if (result) setSearch(result.text);
            }}
            
          />
        )} */}
      </div>
      <input
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        className="input-scanner"
        placeholder="Buscar"
        autoFocus
      />
      <table className="scanner-table">
        <thead>
          <tr>
            <th>Codigo</th>
            <th>Nombre</th>
            <th>Precio</th>
            {/* <th>Accion</th> */}
          </tr>
        </thead>
        <tbody>
          {Array.isArray(productsToRender) &&
            productsToRender.map((product) => (
              <tr
                key={product._id}
                onClick={() => setShowModalProduct(product)}
              >
                <td>{product._id}</td>
                <td>{product.name}</td>
                <td>${product.price}</td>
                {/* <td>
                  <button className="button">Editar</button>
                </td> */}
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
}
